import Button from '../components/Button'

export function getPlanModalProps(props) {
  return {
    title: 'Premium Feature',
    subtitle: 'This functionality is only available for our Insider subscribers.',
    actionItems: [
      {
        title: 'Sign Up for Access',
        theme: Button.THEME.solidPrimary,
        onClick: () => {
          window.open('https://join.gohunt.com/try/insider/')
        },
      },
      {
        title: 'Dismiss',
        theme: Button.THEME.ghostPrimary,
        onClick: () => {
          props.dispatch({
            type: 'modals/close'
          });
        }
      }
    ],
  }
}
